<div class="container-fuid bg-white default-boxrounded">
    <div class="row">
        <div class="col-12 w-100">
            <h3 class="title"><span translate="Settings.OrganisationUsersSection.AddNewUser"></span></h3>
        </div>
    </div>

    <div class="p-4 pt-1">
        <form [formGroup]="form" (ngSubmit)="SubmitUser()">
            <div class="row row-cols-12">
                <div class="mb-3 col-6">
                    <label for="firstname" class="form-label"
                        translate="Settings.AccountProfileSection.Firstname"></label>
                    <input type="text" id="firstname" formControlName="firstname" class="form-control" value="">
                    <app-formcontrol-error-messages [forControl]="firstNameControl"></app-formcontrol-error-messages>
                </div>
                <div class="mb-3 col-6">
                    <label for="prefix" class="form-label"
                        translate="Settings.AccountProfileSection.Preposition"></label>
                    <input type="text" id="prefix" formControlName="prefix" class="form-control" value="">
                    <app-formcontrol-error-messages [forControl]="prefixControl"></app-formcontrol-error-messages>
                </div>
            </div>
            <div class="mb-3 col-12">
                <label for="lastname" class="form-label" translate="Settings.AccountProfileSection.Surname"></label>
                <input type="text" id="lastname" formControlName="lastname" class="form-control" value="">
                <app-formcontrol-error-messages [forControl]="lastNameControl"></app-formcontrol-error-messages>
            </div>
            <div class="mb-3 col-12">
                <label for="email" class="form-label" translate="Settings.AccountProfileSection.EmailAddress"></label>
                <input type="text" id="email" formControlName="email" class="form-control" value="">
                <app-formcontrol-error-messages [forControl]="emailControl"></app-formcontrol-error-messages>
            </div>
            <div class="mb-3 col-12">
                <label for="phoneNumber" class="form-label"
                    translate="Settings.AccountProfileSection.MobilePhoneNumber"><app-info-button
                        labelName="Settings.AccountProfileSection.PhoneNumberTooltip"></app-info-button></label>
                <input type="text" id="phoneNumber" formControlName="phoneNumber" class="form-control" value="">
                <app-formcontrol-error-messages [forControl]="phoneControl"></app-formcontrol-error-messages>
            </div>
            <div class="mb-3 col-12">
                <label for="email" class="form-label" translate="Settings.AccountProfileSection.Language"></label>
                <div ngbDropdown class="dropdown" ngDefaultControl formControlName="language" name="userLanguage"
                    id="userLanguage">
                    <button class="btn btn-sm language dropdown-toggle form-control text-truncate default" type="button"
                        id="dropdownMenu" ngbDropdownToggle>
                        {{ userLanguage | translate }}
                        <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                        <button ngbDropdownItem value="nl" (click)="setUserLanguageWithEvent($event, 'nl')"
                            translate="Language.Dutch"></button>
                        <button ngbDropdownItem value="en" (click)="setUserLanguageWithEvent($event, 'en')"
                            translate="Language.English"></button>
                    </div>
                </div>
                <app-formcontrol-error-messages [forControl]="languageControl"></app-formcontrol-error-messages>
            </div>

            <div class="pt-1 mb-3 col-12">

                <ul class="mt-1 w-100 list-group">
                    <li class="list-group-item subheader d-block align-items-center">
                        <div class="d-flex align-items-center">
                            <label class="form-check-label" for="flexCheckDefault"
                                translate="Settings.AccountProfileSection.Role"></label>
                        </div>
                    </li>
                    <li class="list-group-item d-block nohover align-items-center">
                        <div class="d-flex align-items-center">
                            <input class="checkbox form-check-input defaultheight" type="checkbox"
                                formControlName="NoAdminRights" id="NoAdminRights" (change)="setNoAdminRights()"
                                checked>
                            <label class="form-check-label opacity-100" for="NoAdminRights">
                                <span translate="Roles.Customer"></span>
                            </label>
                        </div>
                    </li>
                    <li class="list-group-item d-block nohover align-items-center"
                        *ngIf="userinfo.isOrganisationAdmin || userinfo.isWhitelabelAdmin || userinfo.isSystemAdmin">
                        <div class="d-flex align-items-center">
                            <input class="checkbox form-check-input defaultheight" type="checkbox"
                                formControlName="OrganisationAdmin" id="OrganisationAdmin" (change)="setAdminRights()">
                            <label class="form-check-label opacity-100" for="flexCheckDefault">
                                <span translate="Roles.OrganisationAdmin"></span>
                            </label>
                        </div>
                    </li>
                    <li class="list-group-item d-block nohover align-items-center"
                        *ngIf="userinfo.isWhitelabelAdmin || userinfo.isSystemAdmin">
                        <div class="d-flex align-items-center">
                            <input class="checkbox form-check-input defaultheight" type="checkbox"
                                formControlName="EnterpriseAdmin" id="EnterpriseAdmin" (change)="setAdminRights()">
                            <label class="form-check-label opacity-100" for="flexCheckDefault">
                                <span translate="Roles.EnterpriseAdmin"></span>
                            </label>
                        </div>
                    </li>
                    <li class="list-group-item d-block nohover align-items-center" *ngIf="userinfo.isSystemAdmin">
                        <div class="d-flex align-items-center">
                            <input class="checkbox form-check-input defaultheight" type="checkbox"
                                formControlName="WhitelabelAdmin" id="WhitelabelAdmin" (change)="setAdminRights()">
                            <label class="form-check-label opacity-100" for="flexCheckDefault">
                                <span translate="Roles.WhitelabelAdmin"></span>
                            </label>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="col-12 mt-4 pb-2 d-table w-100">
                <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="close()"
                        translate>Button.Back</button></span>
                <span class="float-end"><button type="submit" id="buttonSave" class="btn btn-sm btn-primary"
                        [disabled]="buttonDisabled" translate="Button.Add"></button></span>
            </div>
        </form>
    </div>
</div>